<template>
    <div >
        <new-cv-popup
            :data-to-show="stepNewCvPopupDisplayed"
            :errors="errorsCreateNewCv"
            @close="displayPopupNewCV(-1)"
            @createNewCv="(infos) => {newCV(infos)}"
            @changePage="(step) => stepNewCvPopupDisplayed = step"
        />

        <remove-cv-popup
            :data-to-show="isRemoveCvPopupDisplayed"
            :cv-to-delete="cvToDelete"
            @close="displayPopupRemoveCV(false)"
            @removeCV="(cv) => {remove(cv)}"
        />

        <add-button
            class="px-5 lg:px-14 mb-10"
            libelle="Créer un nouveau CV"
            @add="displayPopupNewCV(1)"
        />

        <transition-group
            enter-active-class="ease-in duration-1000"
            enter-class="bg-indigo-300 border-0 rounded-xl"
            enter-to-class="bg-none border-0 rounded-xl"
            leave-active-class="linear duration-1000"
            leave-class="h-20 opacity-100"
            leave-to-class="h-0 opacity-0"
            tag="div"
        >
            <div
                v-for="(cv, i) in listCvs"
                :key="'cv'+i"
                class="odd:bg-indigo-100 odd:bg-opacity-50 hover:bg-indigo-200 odd:hover:bg-indigo-200
                    h-16 lg:h-24 2xl:h-32 pl-5 lg:pl-14
                    grid grid-cols-12 lg:gap-x-4 place-content-center items-center cursor-default"
            >
                <div class="col-span-3 lg:col-span-4 text-base text-gray-900">
                    <!-- Titre CV -->
                    {{cv.name}}
                </div>

                <div class="hidden lg:col-span-4 text-sm line-clamp-2 pr-5 justify-self-start place-self-center italic font-light">
                    <!-- Description -->
                    <p class="break-all">{{cv.description}}</p>
                </div>

                <div class="col-span-3 lg:col-span-1 text-base">
                    <!-- Date création -->
                    {{new Date(cv.created_at).toLocaleDateString('fr')}}
                </div>

                <div class="col-span-3 lg:col-span-2 text-base flex justify-center">
                    {{cv.type === "basic" ? "Classique" : "Dashboard"}}
                </div>

                <div class="col-span-1 relative">
                    <!-- more button -->
                    <div @click.stop="displayMore(i)" class="more-menu p-2 cursor-pointer">
                        <icon name="more-vertical" class="text-pink-600"/>
                    </div>
                    <div
                        v-if="indexMenuToDisplay === i"
                        class="absolute right-5 z-10"
                        v-click-outside="forceHide"
                    >
                        <div class="flex flex-col space-y-2 bg-white rounded-xl p-4 shadow-lg text-sm text-gray-600">
                            <router-link
                                :to="{ name: 'CvForm', params: { user: user.id, id: cv.id } }"
                                class="hover:text-gray-900"
                            >
                                Modifier
                            </router-link>
                            <div
                                @click="dupplicate(i)"
                                class="cursor-pointer hover:text-gray-900"
                            >
                                Dupliquer
                            </div>
                            <div
                                @click.stop="displayPopupRemoveCV(true, cv)"
                                class="cursor-pointer hover:text-gray-900"
                            >
                                Supprimer
                            </div>
                            <div
                                @click="download(i)"
                                class="cursor-pointer hover:text-gray-900"
                            >
                                Télécharger
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition-group>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ActionButton from '../../components/ActionButton.vue';
import Icon from '../../components/Icon.vue';
import Illustration from '../../components/Illustration.vue';
import AddButton from '../../components/Inputs/AddButton.vue';
import ClickOutside from 'vue-click-outside';
import NewCvPopup from './popup/NewCvPopup.vue';
import RemoveCvPopup from './popup/RemoveCvPopup.vue';

export default {
  components:{
    ActionButton,
    Illustration,
    Icon,
    AddButton,
    NewCvPopup,
    RemoveCvPopup,
  },

  props:{
    listCvs:{
      type: Array,
      required: false,
      default: [],
    }
  },

  data(){
    return {
      indexMenuToDisplay: -1,
      stepNewCvPopupDisplayed: -1,
      isRemoveCvPopupDisplayed: false,
      errorsCreateNewCv:{},
      cvToDelete:null
    };
  },

  methods:{
    displayMore(index){
      this.indexMenuToDisplay = index;
    },

    forceHide(e){
      if(!e.target.classList.contains('more-menu')){
        if(this.indexMenuToDisplay > -1){
          this.indexMenuToDisplay = -1;
        }
      }
    },

    modify(index){
      this.$emit('modify', this.listCvs[index]);
    },

    dupplicate(index){
      this.$emit('dupplicate', this.listCvs[index]);
      this.indexMenuToDisplay= -1;
    },

    remove(cv){
      this.$emit('remove', cv);
      this.isRemoveCvPopupDisplayed = false;
    },

    download(index){
      this.$emit('download', this.listCvs[index]);
    },

    displayPopupNewCV(step){
      this.stepNewCvPopupDisplayed = step;
    },

    displayPopupRemoveCV(state, cv=null){
      if(cv){
        this.cvToDelete = cv;
      }
      this.isRemoveCvPopupDisplayed = state;
    },

    newCV(infos){
      this.$emit('newCV', infos);
    }
  },

  computed:{
    ...mapGetters({
      user: 'auth/user',
    })
  },

  directives: {
    ClickOutside
  }

};
</script>
